import React from 'react';
import PT from 'prop-types';
import cIf from 'classnames';

export function Panel({ className, title, subtitle, children }) {
    return (
        <div className={cIf("panel-box", className)}>
            <div className="title">
                <h3>
                    {title}
                    {(subtitle ? <span>{" - " + subtitle}</span> : null)}
                </h3>
            </div>
            <div className="body">
                {children}
            </div>
        </div>
    );
}
Panel.propTypes = {
    title: PT.string,
    subtitle: PT.string,
    className: PT.string,
    children: PT.object
};

Panel.defaultProps = {
    className: ""
};
